import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IListResponse, Nullable } from '@lib/interfaces';
import { TColumn, TColumnSort } from '@lib/modules/table/components';
import { TableModule } from '@lib/modules';
import { CustomersBeneficiaryService } from '@lib/services/customers/customers-beneficiary.service';
import { BaseComponent } from '@lib/components';

@Component({
  selector: 'app-tab-billers',
  standalone: true,
  imports: [CommonModule, TableModule],
  templateUrl: './tab-billers.component.html',
  styleUrls: ['./tab-billers.component.scss']
})
export class TabBillersComponent extends BaseComponent implements OnInit {

  @Input() customerId = '';
  public billerList: Array<any> = [];
  public billerListLoading = false;
  public hasMoreRecords = false;
  protected columns: Array<TColumn> = [
    'name',
    'email',
    'phone',
    'nickname',
    'bank',
    'bank_id',
    'form_of_payment',
    'country',
    'category',
    'category_display_name',
    'subcategory',
    'subcategory_display_name',
    'instrument_currency',
    'instrument_type',
    'instrument_value',
    'relationship',
    'source_of_funds',
    'is_deleted',
    'status',
    'created'
  ];
  protected defaultColumns: Array<string> = ['name', 'email', 'phone', 'status', 'created'];
  protected sortableColumns: Array<string> = ['created'];

  constructor(private customerBeneficiaryService:CustomersBeneficiaryService){
    super();
  }
  private fetchBillers(limit = 10): void {
    this.addSubscription(
        this.customerBeneficiaryService.getBeneficiaryDetails(this.customerId).subscribe({
            next: (aliasListResponse: IListResponse<any>): void => {
                this.hasMoreRecords = aliasListResponse.has_more;
                this.billerList = [...aliasListResponse.data];
                this.billerListLoading = false;
            },
            error: (): void => {
                this.billerListLoading = false;
            },
        }),
    );
  }

  ngOnInit(): void {
    this.billerListLoading = true;
    this.fetchBillers(10);
  }
}
